var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_1398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4927 22.3646L17.0889 17.7684L17.5838 17.839C18.1986 17.9291 18.826 17.8735 19.4155 17.677C20.005 17.4805 20.5402 17.1487 20.978 16.7077C21.4732 16.2104 21.8292 15.5918 22.0108 14.9139C22.1925 14.236 22.1934 13.5223 22.0133 12.844L20.6852 14.1721L20.2716 14.1728H18.8573H17.8561V13.1715L17.8561 11.7573L17.8568 11.3436L19.1848 10.0156C18.5065 9.83548 17.7929 9.83635 17.115 10.018C16.4371 10.1996 15.8185 10.5557 15.3211 11.0508C14.8801 11.4886 14.5483 12.0239 14.3518 12.6134C14.1553 13.2028 14.0997 13.8302 14.1899 14.445L14.2605 14.9399L9.66427 19.5361L12.4927 22.3646ZM12.4927 23.7788L8.25005 19.5361L13.1998 14.5864C13.0871 13.8179 13.1563 13.0336 13.402 12.2967C13.6476 11.5599 14.0627 10.8909 14.614 10.3437C15.4302 9.53071 16.5012 9.02351 17.6474 8.9076C18.7935 8.7917 19.9448 9.07423 20.9072 9.70741L18.8567 11.758V13.1722H20.2709L22.3214 11.1216C22.9546 12.084 23.2371 13.2353 23.1212 14.3815C23.0053 15.5276 22.4981 16.5987 21.6851 17.4148C21.1379 17.9662 20.469 18.3812 19.7321 18.6269C18.9952 18.8725 18.211 18.9418 17.4424 18.829L12.4927 23.7788Z",
    fill: "#414141"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_1398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.6c0a7fcb055c27f24b5f5846e5d462e7.svg";
export { ForwardRef as ReactComponent };